//React Components and Hooks
import { can } from "modules/settings/accessRoles";
import React, { useEffect } from 'react';
import { Link, useParams } from "react-router-dom";
import styled, { withTheme } from "styled-components";
import { spacing } from "@mui/system";
//Material UI Components
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Breadcrumbs from "../../components/BreadCrumb"
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import AppBar from '@mui/material/AppBar';
import moment from 'moment';
import Toolbar from '@mui/material/Toolbar';
import Skeleton from "@mui/material/Skeleton";
import { LeftSidebar } from "layout-blueprints";
import { CSVDownloadButton } from "../../utils/csvUtils";
import {
  Loop as LoopIcon,
  FilterList as FilterListIcon,
} from "@mui/icons-material";
//Custom Components
import BulkCheckEntryTable from '../../modules/payments/components/BulkCheckEntry';


import { setSnackbar } from "../../modules/snackbar/api/snackbar";
import { connect, useDispatch } from 'react-redux';
import {
  Card, Tab, Tabs,
  Divider as MuiDivider,
  Typography as MuiTypography,
  CircularProgress as MuiCircularProgress,
  TextField as MuiTextField,
} from "@mui/material";


import { dateFormatter, txtBoxDateFormatter, formatMoney } from "../../setup/helpers";
// Redux Components
import PropTypes from 'prop-types';
import { login, logout } from '../../modules/user/api/actions';
import AccountPreviewsTable from '../../modules/accountsSearch/components/AccountPreviewsTable';
import PmBillPacketTable from '../../modules/bills/components/PmBillPacketTable';
import StandardHeader from '../../components/global/StandardHeader';
import { searchAccountsByFieldAndValue } from '../../modules/accountsSearch/api/actions';
import { getAnalyticalData, getAllPropertyPreviews, getAllAccountStatusCodes, getAllCustomerTypes, getAllPaymentMethodTypes } from '../../modules/apl/api/actions';
import { updateBulkCheck, createNewAccountPayment, resetBulkCheckEntry, getBulkCheckDailyPaymentsSummary } from '../../modules/payments/api/actions';
//Custom Components
import NavFrame from "../../components/NavFrame"
//Custom Context
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const DashboardToolBarButton = styled(Button)`
  padding: 4px;
  min-width: 0;
  svg {
    width: 2em;
    height: 2em;
  }
`;

const emptyAccountExport = {
  AccountNumber: "",
  AccountName: "",
  Address: "",
  PaymentDate: "",
  CheckNumber: "",
  PaymentAmount: ""
}

const AccountTotalExport = (total) => {
  return {
    AccountNumber: "",
    AccountName: "",
    Address: "",
    PaymentDate: "",
    CheckNumber: "Total: ",
    PaymentAmount: formatMoney(total)
  }
}

const todayFileFormat = moment().format('MM-DD-YYYY');
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
//Styles
const useStyles = makeStyles((theme) => ({
  totalContainer: {
    backgroundColor: theme.palette.secondary.main,
    width: "97%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "1.5rem",
  },
  toolbarButtons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  totalText: {
    color: theme.palette.secondary.contrastText
  },
  link: {
    textDecoration: "none",
    color: 'white',
    '&:hover': {
      fontWeight: "bold",
      textDecoration: "underline"
    }
  },
}))

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const TextField = styled(MuiTextField)(spacing);
const Divider = styled(MuiDivider)(spacing);

const BulkCheckEntryPage = (props) => {

  const [tabValue, setTabValue] = React.useState(0);
  const classes = useStyles()
  const dispatch = useDispatch();
  const onFieldChange = (event) => {
    if (event.target.type == "number") {
      props.payments.newBulkCheck[event.target.name] = Number(event.target.value);
    }
    else {
      props.payments.newBulkCheck[event.target.name] = event.target.value;
    }
    props.updateBulkCheck(props.payments.newBulkCheck);
  }

  const addAllPayments = (payments) => {
    if (payments.length > 0) {
      dispatch(setSnackbar(true, "warning", "Creating Account Payments"));
    }
    let typeID = -1;
    for (var x = 0; x < props.apl.genericTypes.paymentMethodType.data.length; x++) {
      if (props.apl.genericTypes.paymentMethodType.data[x].description == "Check") {
        typeID = props.apl.genericTypes.paymentMethodType.data[x].id;
      }
    }
    payments.map(account => {
      const today = moment().format("MM/DD/YYYY");
      if (account.amountCovered && account.amountCovered != 0 && account.accountNum != "") {
        let paymentNote = "BULK CHECK PAYMENT - Check# " + props.payments.newBulkCheck.checkNumber;
        var newPayment = {
          acctNum: account.accountNum,
          paymentType: typeID,
          paymentNote: paymentNote,
          paymentAmount: (account.amountCovered || 0),
          paymentTypeDesc: "Check",
          routingNumber: "",
          accountNumber: "", //Bank account #
          nameOnCard: "",
          cardNumber: "",
          cardType: "",
          cardExpMonth: "",
          cardExpYear: "",
          cardCvv: "",
          status: "Posted",
          checkNumber: props.payments.newBulkCheck.checkNumber,
          paymentDate: today,
          transactionFee: 0,
          transactionTotal: 0,
        };
        props.createNewAccountPayment(account.uuid, newPayment).then(() => {
          props.getBulkCheckDailyPaymentsSummary();
          dispatch(setSnackbar(true, "success", "Payment created successfully"));
        });
      }

    });
    dispatch(setSnackbar(true, "warning", "Finished processing new account payments, waiting on response...."));
    props.resetBulkCheckEntry();
  }
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleRefreshClick = () => {
    props.getBulkCheckDailyPaymentsSummary();
  };

  useEffect(() => {
    props.getAllCustomerTypes();
    props.getAllAccountStatusCodes();
    props.getAllPaymentMethodTypes();
    props.getBulkCheckDailyPaymentsSummary();
    props.getAllPropertyPreviews();
    document.title = "Ubil+ Bulk Check Entry";
  }, [props.user])

  const exportCheckData = () => {
  };

  const ToolbarInfo = () => {
    if (props.payments.bulkCheckCurrentSummary != null) {
      return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', gap: 1, ...classes.toolbarButtons }}>
            <DashboardToolBarButton size="small" mr={2}
              onClick={handleRefreshClick}>
              <LoopIcon />
            </DashboardToolBarButton>
            <Button variant="contained" color="secondary">
              <CSVDownloadButton
                className={classes.link}
                filename={`BulkCheckPaymentDailyReport_${props.payments.newBulkCheck.checkNumber}_${todayFileFormat}.csv`}
                data={props.payments.bulkCheckCurrentSummary.previewData}
              >
                Daily Report
              </CSVDownloadButton>
            </Button>
          </Box>

          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            <Box sx={{ flex: '1 1 25%', minWidth: '200px' }}>
              <Typography variant="h6" className={classes.typography}>
                {props.payments.bulkCheckCurrentSummary.checksPosted}
              </Typography>
              <Typography variant="body2" className={classes.typography}>
                Posted Checks:
              </Typography>
            </Box>
            <Box sx={{ flex: '1 1 25%', minWidth: '200px' }}>
              <Typography variant="h6" className={classes.typography}>
                {formatMoney(props.payments.bulkCheckCurrentSummary.TotalValuePaid)}
              </Typography>
              <Typography variant="body2" className={classes.typography}>
                Amount Posted :
              </Typography>
            </Box>
            <Box sx={{ flex: '1 1 25%', minWidth: '200px' }}>
              <Typography variant="h6" className={classes.typography}>
                {props.payments.bulkCheckCurrentSummary.accountsEffected}
              </Typography>
              <Typography variant="body2" className={classes.typography}>
                Accounts Effected :
              </Typography>
            </Box>
            <Box sx={{ flex: '1 1 25%', minWidth: '200px' }}>
              <Typography variant="h6" className={classes.typography}>
                {props.payments.bulkCheckCurrentSummary.totalRows}
              </Typography>
              <Typography variant="body2" className={classes.typography}>
                Account Payments Made :
              </Typography>
            </Box>
          </Box>
        </Box>
      )
    }
    else if (props.payments.bulkCheckCurrentSummary == null && props.payments.bulkCheckCurrentSummaryIsLoading) {
      return (<>
        <Box sx={{ width: '100%' }}>
          <Skeleton
            variant="rect"
            height="60px"
            style={{
              backgroundColor: `#bdbfbe`,
              padding: 6,
              margin: 6,
              marginBottom: 3,
            }}
          />
        </Box>
      </>)
    }
    else {
      return (<></>)
    }
  };
  var totalRemaining = props.payments.newBulkCheck.amountPaid;
  var tableData = [];
  if (props.payments.bulkCheckSelectedAccounts.items.length > 0) {
    var today = moment().format('YYYY/MM/DD HH:mm:ss');
    for (var x = 0; x < props.payments.bulkCheckSelectedAccounts.items.length; x++) {
      if (props.payments.bulkCheckSelectedAccounts.items[x].amountCovered > 0) {
        totalRemaining = (totalRemaining - props.payments.bulkCheckSelectedAccounts.items[x].amountCovered).toFixed(2);
        var name = props.payments.bulkCheckSelectedAccounts.items[x].lastName;
        if (props.payments.bulkCheckSelectedAccounts.items[x].firstName != null) {
          name = props.payments.bulkCheckSelectedAccounts.items[x].firstName + ", " + props.payments.bulkCheckSelectedAccounts.items[x].lastName;
        }
        var address = "NOT LISTED";
        if (props.payments.bulkCheckSelectedAccounts.items[x].serviceAddress1 != null) {
          address = props.payments.bulkCheckSelectedAccounts.items[x].serviceAddress1;
        }
        if (props.payments.bulkCheckSelectedAccounts.items[x].serviceAddress2 != null) {
          address = props.payments.bulkCheckSelectedAccounts.items[x].serviceAddress1 + ", " + props.payments.bulkCheckSelectedAccounts.items[x].serviceAddress2;
        }
        var newAccountExport = {
          AccountNumber: props.payments.bulkCheckSelectedAccounts.items[x].accountNum,
          AccountName: name,
          Address: address,
          PaymentDate: today,
          // Needs to be done so excel wont auto, format to scientific notation
          CheckNumber: `# ${props.payments.newBulkCheck.checkNumber}`,
          PaymentAmount: formatMoney(props.payments.bulkCheckSelectedAccounts.items[x].amountCovered)
        }
        tableData.push(newAccountExport);
      }
    }
    tableData.push(emptyAccountExport);
    tableData.push(AccountTotalExport(props.payments.newBulkCheck.amountPaid - totalRemaining));
  }
  return (
    <LeftSidebar>
      <StandardHeader title="Bulk Check Entry" rightSideToolBar={can(props.user.details, "accountingTools") && <ToolbarInfo />} />
      <Divider className="mb-3 mt-3" />
      {(props.user.details.accounting || props.user.details.administration || props.user.details.isSuperUser) ? (
        <Box sx={{ width: '100%' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ width: '100%' }}>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    my={2}
                    fullWidth
                    type="text"
                    id="checkNumber"
                    label="Check Number"
                    value={props.payments.newBulkCheck.checkNumber}
                    onChange={onFieldChange}
                    autoComplete={"off"}
                    //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                    variant="outlined"
                    name="checkNumber"
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                </Box>
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                  <TextField
                    my={2}
                    fullWidth
                    type="number"
                    id="amountPaid"
                    label="Amount Paid"
                    value={props.payments.newBulkCheck.amountPaid}
                    onChange={onFieldChange}
                    autoComplete={"off"}
                    //onBlur={() =>{ props.handleBillingProcessSubmission(props.billing.data.billInProgress, false); } }
                    variant="outlined"
                    name="amountPaid"
                    slotProps={{ inputLabel: { shrink: true } }}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
              {(totalRemaining == 0 && props.payments.newBulkCheck.amountPaid > 0 && props.payments.newBulkCheck.checkNumber != "" && tableData.length > 0) ?
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="contained" color="secondary">
                    <CSVDownloadButton
                      className={classes.link}
                      filename={`BulkCheckPayment_${props.payments.newBulkCheck.checkNumber}_${todayFileFormat}.csv`}
                      data={tableData}
                    >
                      Export
                    </CSVDownloadButton>
                  </Button>
                  <Button variant="contained" color="secondary" onClick={() => {
                    addAllPayments(props.payments.bulkCheckSelectedAccounts.items)
                  }}>POST PAYMENTS</Button>
                </Box>
                :
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Button variant="contained" color="secondary" disabled>EXPORT</Button>
                  <Button variant="contained" color="secondary" disabled onClick={() => {
                    addAllPayments(props.payments.bulkCheckSelectedAccounts.items)
                  }}>POST PAYMENTS</Button>
                </Box>
              }
            </Box>
            <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
              <Typography variant="h5" className={classes.typography}>
                Check Total Remaining: {formatMoney(totalRemaining)}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, width: '100%' }}>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <AppBar position="static" color="primary">
                  <Tabs value={tabValue}
                    onChange={handleTabChange}
                    aria-label="Account Management Tabs"
                    variant="scrollable"
                    scrollButtons="auto">
                    <Tab label="Accounts" {...a11yProps(0)} />
                    <Tab label="PM Packets" {...a11yProps(1)} />
                  </Tabs>
                </AppBar>
                <TabPanel value={tabValue} index={0} style={{ marginTop: 16 }}>
                  <AccountPreviewsTable isBulkCheckEntry={true} minAccountObj={true} SearchOnTypeInput={false} />
                </TabPanel>
                <TabPanel value={tabValue} index={1}>
                  <PmBillPacketTable isBulkCheckEntry={true} />
                </TabPanel>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <BulkCheckEntryTable />
              </Box>
            </Box>

          </Box>
        </Box>) : (<h3>You do not have Bulk Check privileges</h3>)
      }
    </LeftSidebar >
  )
}

BulkCheckEntryPage.propTypes = {
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  accountsSearch: PropTypes.object.isRequired,
  payments: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  searchAccountsByFieldAndValue: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
  getAllAccountStatusCodes: PropTypes.func.isRequired,
  getAllCustomerTypes: PropTypes.func.isRequired,
  updateBulkCheck: PropTypes.func.isRequired,
  getAllPaymentMethodTypes: PropTypes.func.isRequired,
  createNewAccountPayment: PropTypes.func.isRequired,
  resetBulkCheckEntry: PropTypes.func.isRequired,
  getBulkCheckDailyPaymentsSummary: PropTypes.func.isRequired,
}

// Component State
function BulkCheckEntryPageState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
    accountsSearch: state.accountsSearch,
    payments: state.payments
  }
}
export default connect(BulkCheckEntryPageState, { logout, searchAccountsByFieldAndValue, getAllPropertyPreviews, getAllCustomerTypes, getAllAccountStatusCodes, updateBulkCheck, getAllPaymentMethodTypes, createNewAccountPayment, resetBulkCheckEntry, getBulkCheckDailyPaymentsSummary })(BulkCheckEntryPage)